import { lazy } from 'react';

const SurveyDetailsModal = lazy(
  () => import('modules/StudentDashboard/modals/SurveyDetailsModal'),
);

const StaffScheduleMeetingModal = lazy(
  () => import('modules/StudentDashboard/modals/ScheduleMeetingModal'),
);

export default {
  SURVEY_DETAILS_MODAL: SurveyDetailsModal,
  STAFF_SCHEDULE_MEETING_MODAL: StaffScheduleMeetingModal,
};
